import { CheckCircle2, MessageSquare, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

export const SubscriptionSuccess = () => (
  <div className="min-h-screen bg-gradient-to-b from-[#141419] via-[#0c0c10] to-black text-white flex items-center justify-center p-4 relative overflow-hidden">
    <div
      className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[350px] bg-purple-600/15 blur-[140px] pointer-events-none rounded-full"
      aria-hidden="true"
    />

    <div className="glass-card p-8 sm:p-10 max-w-lg w-full text-center rounded-3xl border border-purple-500/30 shadow-2xl relative z-10 space-y-6">
      <div className="w-16 h-16 rounded-full bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center mx-auto text-emerald-400">
        <CheckCircle2 className="w-9 h-9" />
      </div>

      <div className="space-y-2">
        <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-purple-500/15 border border-purple-500/30 text-purple-300 text-xs font-bold uppercase tracking-wider">
          <Sparkles className="w-3.5 h-3.5 text-purple-400" />
          <span>Premium Activated</span>
        </div>
        <h1 className="text-2xl sm:text-3xl font-black text-white">
          Welcome to Agent FOMO Premium!
        </h1>
        <p className="text-sm text-gray-300 leading-relaxed font-light">
          Your subscription is now active. Your monthly message and
          recommendation quotas have been removed. You can now chat freely
          without limits.
        </p>
      </div>

      <div className="pt-2 flex flex-col sm:flex-row gap-3 justify-center">
        <a
          href="https://wa.me/972504244206"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-2xl bg-emerald-600 hover:bg-emerald-500 text-white font-bold text-sm shadow-lg shadow-emerald-600/20 transition active:scale-95"
        >
          <MessageSquare className="w-4 h-4" />
          <span>Open WhatsApp Chat</span>
        </a>
        <Link
          to="/events"
          className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-2xl bg-white/10 hover:bg-white/15 text-white font-semibold text-sm border border-white/10 transition active:scale-95"
        >
          <span>Explore Events</span>
        </Link>
      </div>
    </div>
  </div>
);
